import { VEHICLE_REGISTRATION_METHOD } from "@shared/constants";

import { normaliseCountryValue } from "./resolveCountryOption";

const isPostalCodeAllowed = (method, postalCode) => {
  if (!method?.allowedPostalCodesRegex) {
    return true;
  }
  if (!postalCode) {
    return true;
  }
  try {
    return new RegExp(method.allowedPostalCodesRegex).test(postalCode);
  } catch {
    return true;
  }
};

export const computeAvailableRegistrationMethods = (
  vehicleRegistration,
  postalCode,
  { isKeyAccount, country, domesticCountry } = {}
) => {
  const { CITROEN, MYSELF } = VEHICLE_REGISTRATION_METHOD;
  const result = [];
  if (!vehicleRegistration) {
    return result;
  }

  const isCitroenAllowedForCountry =
    !domesticCountry ||
    !country ||
    normaliseCountryValue(country) === normaliseCountryValue(domesticCountry);

  const passes = method =>
    method?.enabled && isPostalCodeAllowed(method, postalCode);

  if (passes(vehicleRegistration.selfRegistration) && !isKeyAccount) {
    result.push({ ...vehicleRegistration.selfRegistration, method: MYSELF });
  }

  if (
    isCitroenAllowedForCountry &&
    passes(vehicleRegistration.citroenRegistration)
  ) {
    result.push({
      ...vehicleRegistration.citroenRegistration,
      method: CITROEN,
    });
  }

  return result;
};
